import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

import mixinDisabled from '../../mixins/disabled';

export type PhxButtonUpsellRole = 'primary' | 'secondary';

const baseButtonUpsellMixin = mixinDisabled(class { constructor() {} });

@Component({
  selector: '[phx-button-upsell]',
  templateUrl: './phx-button-upsell.component.html',
  styleUrls: ['./phx-button-upsell.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: ['phxDisabled'],
  host: {
    class: 'phx-button-upsell',
    '[class.phx-button-upsell-primary]': `phxButtonRole === 'primary'`,
    '[class.phx-button-upsell-secondary]': `phxButtonRole === 'secondary'`,
    '[class.phx-disabled]': 'phxDisabled === true',
    '[class.phx-full-width]': 'phxFullWidth',
    '[class.phx-button-upsell-loading]': 'phxLoading',
    '[attr.disabled]': 'phxDisabled || phxLoading || null',
    '[attr.tabindex]': '(phxDisabled || phxLoading) ? -1 : null',
  },
})
export class PhxButtonUpsellComponent extends baseButtonUpsellMixin {
  @Input() public phxButtonRole: PhxButtonUpsellRole = 'primary';
  @Input() public phxLoading: boolean = false;
  @Input() public phxFullWidth: boolean = false;
  @Input() public phxPrefixIcon: string;

  @Output() public phxOnClick = new EventEmitter<MouseEvent | KeyboardEvent>();

  @HostListener('mouseup', ['$event'])
  @HostListener('keyup.space', ['$event'])
  @HostListener('keyup.enter', ['$event'])
  public handleClick(event: MouseEvent | KeyboardEvent): void {
    if (this.phxLoading) return;
    this.phxOnClick.emit(event);
  }
}
